import * as React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Login from './pages/Login';

import SignUp from './pages/Signup';
import Home from './pages/Home';
import Settings from './pages/Settings';
import Indices from './pages/Indices';

const Router = () => {
  return (
    <BrowserRouter>
      <React.Suspense>
        <Routes>
          <Route path="/index.html" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup/buildium" element={<SignUp />} />
          <Route path="/" element={<Home />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/indices" element={<Indices />} />
        </Routes>
      </React.Suspense>
    </BrowserRouter>
  );
};

export default Router;
